import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CloudUpload({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M7.39977 17H6.98977C4.21977 17 1.98977 14.76 1.98977 12H1.98877C1.98877 9.50001 3.83877 7.39001 6.30877 7.06001V7.05001C7.12877 4.61001 9.40877 2.98001 11.9788 2.98001C15.2888 2.98001 17.9788 5.66001 17.9788 8.98001C20.1788 8.98001 21.9788 10.77 21.9788 12.98C21.9788 15.18 20.1788 16.98 17.9788 16.98H16.5688M13.9998 18L11.9998 16M11.9998 16L9.99977 18M11.9998 16V21" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CloudUpload;